import { useContext } from "react";
import { AppContext } from "../../app/store/AppStore";

export const useAppContext = () => {
  const appContext = useContext(AppContext);
  return appContext;
};
